import { CARAVAN_TRIP } from '../config/trip'

export const TRIP_TIME_ZONE = CARAVAN_TRIP.timeZone

export type TripClockParts = {
  date: string
  time: string
  hour: number
  minute: number
}

function numericPart(parts: Intl.DateTimeFormatPart[], type: Intl.DateTimeFormatPartTypes): number {
  return Number(parts.find((part) => part.type === type)?.value ?? '0')
}

export function tripClockParts(instant: Date): TripClockParts {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: TRIP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(instant)
  const year = numericPart(parts, 'year')
  const month = numericPart(parts, 'month')
  const day = numericPart(parts, 'day')
  const hour = numericPart(parts, 'hour')
  const minute = numericPart(parts, 'minute')
  return {
    date: `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
    time: `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`,
    hour,
    minute,
  }
}

export function tripDateKey(instant: Date): string {
  return tripClockParts(instant).date
}

export function isTripProductDay(productDay: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/u.test(productDay) &&
    productDay >= CARAVAN_TRIP.startsOn &&
    productDay <= CARAVAN_TRIP.endsOn
}

export function defaultTripProductDay(instant = new Date()): string {
  const current = tripDateKey(instant)
  if (current < CARAVAN_TRIP.startsOn) return CARAVAN_TRIP.startsOn
  if (current > CARAVAN_TRIP.endsOn) return CARAVAN_TRIP.endsOn
  return current
}

export function isTripTimeReached(instant: Date, productDate: string, localTime: string): boolean {
  const current = tripClockParts(instant)
  return `${current.date}T${current.time}` >= `${productDate}T${localTime}`
}

function offsetAt(instantMs: number): number {
  const parts = tripClockParts(new Date(instantMs))
  const [year, month, day] = parts.date.split('-').map(Number)
  return Date.UTC(year ?? 0, (month ?? 1) - 1, day ?? 1, parts.hour, parts.minute) - instantMs
}

export function tripLocalInstant(productDate: string, localTime: string): string {
  const [year, month, day] = productDate.split('-').map(Number)
  const [hour, minute] = localTime.split(':').map(Number)
  const naiveUtc = Date.UTC(year ?? 0, (month ?? 1) - 1, day ?? 1, hour ?? 0, minute ?? 0)
  let instant = naiveUtc - offsetAt(naiveUtc)
  instant = naiveUtc - offsetAt(instant)
  return new Date(instant).toISOString()
}

export function defaultRevealInstant(
  productDate: string,
  kind: 'daily' | 'group_result',
): string {
  return tripLocalInstant(productDate, kind === 'daily' ? '02:00' : '22:00')
}
